import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorMappingInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          const message = this.humanMessage(err);

          // Map to a consistent error shape for consumers
          // Preserve headers for retry logic (e.g., Retry-After)
          const mapped = {
            code: err.status,
            message,
            retryable: [0, 400, 408, 429, 500, 502, 503, 504].includes(
              err.status
            ),
            url: err.url,
            headers: err.headers,
          };
          return throwError(() => mapped);
        }
        return throwError(() => err);
      })
    );
  }

  private humanMessage(err: HttpErrorResponse): string {
    if (err.status === 0) return 'Network error. Please check your connection.';
    if (err.status === 429) return 'Rate limited. Please try again shortly.';
    if (err.status === 408) return 'Request timed out. Please retry.';
    if (err.status >= 500) return 'Service temporarily unavailable.';
    return err.error?.message || err.message || 'Request failed.';
  }
}
